import { Helmet } from "react-helmet";
import Navbar from "../components/universal/navbar";
import Header from "../components/complain-policy/hero";
import PP from "../components/complain-policy/content";
import CTA from "../components/universal/cta";
import Contact from "../components/universal/contact";
import Footer from "../components/universal/footer";

function Index() {
  return (
    <div>
      <Helmet>
        <title>Dental Implants in Ilkley | Complaints Policy</title>
        <link
          rel="canonical"
          href="https://www.dentalimplants-ilkley.com/complain-policy"
        />
        <meta
          name="description"
          content="Learn how to submit a complaint at Dental Implants Ilkley. We’re committed to patient satisfaction and resolving concerns promptly and professionally."
        />
      </Helmet>
      <Navbar />
      <Header />
      <PP />
      <CTA />
      <Contact />
      <Footer />
    </div>
  );
}

export default Index;
